import React from "react";

import { MessageTemplateActions } from "../../../../../../types/MessageTemplateEnums";
import SMSStatusCellContent from "../components/SMSStatusCellContent";

import base from "./base";

import { Column, ColumnId } from ".";

function smsWillBeAtStatus({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.SMSWillBeAtStatus,
		(item) => (
			<SMSStatusCellContent
				item={item}
				type={MessageTemplateActions.WILL_BE_TIME}
				language={language}
			/>
		),
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default smsWillBeAtStatus;
